import type { HTMLAttributes } from 'react';

import { cn } from '@/shared/utils';

export function WorkspaceContainer({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn(
				'mx-auto w-[calc(100%-32px)] max-w-[960px] sm:w-[calc(100%-64px)]',
				className,
			)}
			{...props}
		/>
	);
}
